var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"launchpad-agreement page-content"},[_c('div',{staticClass:"main-wrap main-wrap--narrow"},_vm._l((_vm.$t('launchpad.disclaimer.undercut')),function(paragraph,index){return _c('p',{key:index,class:{
        'launchpad-agreement__title': !(index - 1),
        'launchpad-agreement__bold': _vm.format.includes(Number(index)),
      }},[_vm._v(" "+_vm._s(paragraph)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }